import axios, { AxiosInstance, AxiosError } from 'axios';
import { API_BASE_URL } from '../config/api';

// Create axios instance
const api: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 30000, // 30 seconds timeout
  withCredentials: true // Enable CORS credentials
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    console.log('🔍 API Request:', (config.baseURL || '') + (config.url || ''));
    const token = localStorage.getItem('fotomista_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('fotomista_token');
      localStorage.removeItem('fotomista_user');
      if (window.location.pathname.includes('/admin') || window.location.pathname.includes('/pass')) {
        window.location.href = '/admin-login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;